import { TILES_PER_ROW } from '../constants';

export function getUV(tileIndex: number): [number, number, number, number] {
  const col = tileIndex % TILES_PER_ROW;
  const row = Math.floor(tileIndex / TILES_PER_ROW);
  const size = 1 / TILES_PER_ROW;
  const u0 = col * size;
  const v0 = 1 - (row + 1) * size;
  const u1 = (col + 1) * size;
  const v1 = 1 - row * size;
  return [u0, v0, u1, v1];
}
